import { Box, Typography, Tooltip } from "@mui/material";
// config
import colors from "../../../config/colors";

const CONVERSION_BUCKETS = [
  {
    label: "Emerging",
    color: colors.primary100,
    value: "<2%",
  },
  {
    label: "Consistent",
    color: colors.primary100,
    value: "2-4%",
  },
  {
    label: "Growing",
    color: colors.primary100,
    value: "4-6%",
  },
  {
    label: "Strong",
    color: colors.primary100,
    value: "6-8%",
  },
  {
    label: "Top-Tier",
    color: colors.primary100,
    value: ">8%",
  },
];

// Tooltip content for conversion rate buckets
const ConversionTooltipContent = () => (
  <Box sx={{ p: 1 }}>
    <Typography
      variant="subtitle2"
      sx={{ fontWeight: "bold", mb: 1, fontSize: 12 }}
    >
      Conversion Rate Buckets:
    </Typography>
    {CONVERSION_BUCKETS.map((bucket, index) => (
      <Typography key={index} variant="body2" sx={{ fontSize: 11, mb: 0.3 }}>
        • {bucket.label} ({bucket.value})
      </Typography>
    ))}
  </Box>
);

const Conversion = ({ item }) => {
  const conversionRate = item?.overall_conversion_percentage || 0;

  const getConversionTier = (rate) => {
    if (rate >= 8) return CONVERSION_BUCKETS[4]; // Excellent
    if (rate >= 6) return CONVERSION_BUCKETS[3]; // Good
    if (rate >= 4) return CONVERSION_BUCKETS[2]; // Average
    if (rate >= 2) return CONVERSION_BUCKETS[1]; // Normal
    return CONVERSION_BUCKETS[0]; // Poor
  };

  const tier = getConversionTier(conversionRate);

  return (
    <Tooltip
      title={<ConversionTooltipContent />}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: colors.gray900,
            color: colors.white,
            fontSize: 11,
            maxWidth: 220,
          },
        },
        arrow: {
          sx: {
            color: colors.gray900,
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: tier.color,
          padding: "2px 8px",
          borderRadius: 0.5,
          textAlign: "center",
          minWidth: "fit-content",
          display: "inline-block",
          cursor: "help",
        }}
      >
        <Typography fontSize={10} fontWeight={500} lineHeight="16px">
          {tier.label}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default Conversion;
